// eslint-disable-next-line @typescript-eslint/naming-convention
export enum deliveryOptionsEnum {
    email,
    rssFeed,
    digest
}
